import zreportapi from "../../../../services/zreport";

export const fetchCoinSettlementsApi = async (branchId, transactionDate) => {
  const response = await zreportapi.get(
    `DataCoinSettlements/branch/${branchId}/transaction-date/${transactionDate}?page=1&size=100`
  );
  return response.data;
};

export const addCoinSettlementApi = async (settlement) => {
  const response = await zreportapi.post("DataCoinSettlements", settlement);
  return response.data;
};

export const updateCoinSettlementApi = async (id, settlement) => {
  const response = await zreportapi.put(`DataCoinSettlements/${id}`, settlement);
  return response.data;
};

export const deleteCoinSettlementApi = async (id) => {
  const response = await zreportapi.delete(`DataCoinSettlements/${id}`);
  return response.data;
};
